Postlogin = (function (postlogin) {
    postlogin.EasyLoginsList = {};
    const self = postlogin.EasyLoginsList;

    self.init = function () {
        initBootstrapTable();

        if ($('.expires-time').length) {
            $('.expires-time').each(function () {
                const timer = this;
                const expiresDate = $(this).html();

                // Set the date we're counting down to
                const countDownDate = new Date(expiresDate).getTime();

                // Update the count down every 1 second
                const x = setInterval(() => {
                    // Get todays date and time
                    const now = new Date().getTime();

                    // Find the distance between now an the count down date
                    const distance = countDownDate - now;

                    // Time calculations for days, hours, minutes and seconds
                    const hours = Math.floor(distance / (1000 * 60 * 60));
                    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                    // Display the result in the element with id="demo"
                    $(timer).html(`${hours}h ${minutes}m ${seconds}s `);

                    // If the count down is finished, write some text
                    if (distance < 0) {
                        clearInterval(x);
                        $(timer).html('EXPIRED');
                    }
                }, 1000);
            });
        }
    };

    const $easyloginListTable = $('#easy-logins-table');
    const initBootstrapTable = function () {
        const columns = [
            {
                align: 'center',
                field: 'code',
                sortable: true,
                title: 'Code',
                valign: 'middle',
                formatter: (value) => `<span class="easy-login-code"> ${value} </span>`,
            },
            {
                align: 'center',
                field: 'label',
                sortable: true,
                title: 'Label',
                valign: 'middle',
            },
            {
                align: 'left',
                field: 'creator_id',
                sortable: true,
                title: 'Creator',
                valign: 'middle',
                formatter: (value, row) => `${row.first_name} ${row.last_name}`,
            },
            {
                align: 'left',
                field: 'date_created',
                sortable: true,
                title: 'Created',
                valign: 'middle',
                formatter: (value) => (value ? moment(value).format('l') : '-'),
            },
            {
                align: 'left',
                field: 'date_expires',
                sortable: true,
                title: 'Expires',
                valign: 'middle',
                formatter: (value) => (value == null ? 'Never' : value),
            },
            {
                align: 'left',
                field: 'easy_login_student',
                sortable: false,
                title: 'Students',
                valign: 'middle',
                formatter: (value) => {
                    const studentList = `<ul class="list-unstyled easy-login-students">
                            ${value
                        .map((studentData) => {
                            const { student } = studentData;
                            const usersViewUrl = $easyloginListTable.data('users-view-url').replace(':user_id', student.user_id);
                            const studentName = `${student.first_name} ${student.last_name}` === ' '
                                ? `${student.username}`
                                : `${student.first_name} ${student.last_name}`;

                            const students = `<li class="">
                                        <a href="${usersViewUrl}" class="btn btn-default btn-sm student open-student" data-id="${student.user_id}">
                                            ${studentName}
                                        </a>
                                    </li>`;

                            const studentsLoggedIn = `
                                    <li class="">
                                        <div class="btn-group student logged-in active-user">
                                            <a href="${usersViewUrl}" data-id="${student.user_id}" type="button" class="btn btn-success btn-sm open-student">${studentName}</a>
                                            <button type="button" class="btn btn-success btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                            </button>
                                            <ul class="dropdown-menu">
                                                <li><button type="button" data-id="${student.user_id}" class="logout-user-btn">Logout User</button></li>
                                            </ul>
                                        </div>
                                    </li>`;

                            return studentData.authentication_token ? studentsLoggedIn : students;
                        })
                        .join('')}
                        </ul>`;

                    return studentList;
                },
            },
            {
                align: 'center',
                field: 'actions',
                sortable: false,
                title: 'Actions',
                valign: 'middle',
                class: 'user-actions',
                formatter: (value, row) => {
                    if (row.can_manage) {
                        const easyLoginEditUrl = $easyloginListTable.attr('data-easy-login-edit-url').replace(':easy_login_code', row.code);
                        const easyLoginDeleteUrl = $easyloginListTable
                            .attr('data-easy-login-delete-url')
                            .replace(':easy_login_id', row.easy_login_id);

                        return `
                                <a href="${easyLoginEditUrl}" class="btn btn-hollow-blue btn-sm">Edit</a>
                                <form action="${easyLoginDeleteUrl}" method="post" class="delete-entry">
                                    <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                    <input type="hidden" name="_METHOD" value="DELETE"/>
                                    <button type="submit" class="btn btn-hollow-pink btn-sm">Delete</button>
                                </form>
                            `;
                    }

                    return value;
                },
            },
        ];

        if (Jr.getCurrentUserRoleId() === 3) {
            columns.find((x) => x.field === 'creator_id').visible = false;
        }

        $easyloginListTable.bootstrapTable({
            classes: 'table table-hover table-condensed',
            clickToSelect: false,
            contentType: 'application/x-www-form-urlencoded',
            formatNoMatches() {
                return 'No EasyLogins to show';
            },
            idField: 'code',
            maintainSelected: false,
            method: 'post',
            minimumCountColumns: '2',
            pageSize: 25,
            pagination: true,
            search: true,
            searchAlign: 'left',
            showColumns: false,
            showPaginationSwitch: false,
            showRefresh: false,
            showToggle: false,
            sidePagination: 'server',
            sortName: 'date_created',
            sortOrder: 'desc',
            striped: true,
            toolbar: '#report-toolbar',
            toolbarAlign: 'right',
            url: '/easy-logins/json/',
            queryParamsType: 'other',
            queryParams(params) {
                const myParams = {};
                myParams.search_term = params.searchText;
                myParams.page = params.pageNumber;
                myParams.page_size = params.pageSize;
                myParams.order_by = params.sortName;
                myParams.sort_order = params.sortOrder;

                return myParams;
            },
            columns,
            responseHandler(res) {
                return {
                    total: res.meta.total,
                    rows: res.data,
                };
            },
            onLoadSuccess() {
                $('time.timeago').timeago();
            },

            rowStyle(row) {
                let classes = '';

                if (row.authentication_token != null) {
                    classes += 'success ';
                }
                if (row.is_active === 0) {
                    classes += 'danger ';
                }

                return {
                    classes,
                };
            },
        });

        $('body').on('click', '.logout-user-btn', (e) => {
            e.preventDefault();
            const userId = $(e.currentTarget).data('id');
            const logoutUserUrl = $easyloginListTable.attr('data-user-logout-url').replace(':user_id', userId);

            $.ajax({
                url: logoutUserUrl,
                type: 'post',
                success() {
                    $easyloginListTable.bootstrapTable('refresh');
                },
            });
        });
    };

    return postlogin;
}(Postlogin || {}));
